import {
  FunnelConfig,
  FunnelRequestFilters,
  LightFunnel,
  LightFunnelRequestFilters,
  StaticProps,
} from '../../entities';
import { FunnelService } from '../../interfaces';
import { FunnelDto } from './dto';

export class FunnelServiceDecorator implements FunnelService {
  constructor(private readonly funnelService: FunnelService) {}

  getFunnels(filters?: Partial<FunnelRequestFilters>): Promise<Array<FunnelConfig> | null> {
    return this.funnelService.getFunnels(filters);
  }

  getFunnelsRawResponse(filters?: Partial<FunnelRequestFilters>): Promise<Array<FunnelDto> | null> {
    return this.funnelService.getFunnelsRawResponse(filters);
  }

  getLightFunnels(filters: LightFunnelRequestFilters): Promise<Array<LightFunnel> | null> {
    return this.funnelService.getLightFunnels(filters);
  }

  getFunnelsPaths(funnels: Array<FunnelConfig>): StaticProps[] {
    return this.funnelService.getFunnelsPaths(funnels);
  }

  getFunnelsPathsWithSubRouts(funnels: Array<FunnelConfig>): StaticProps[] {
    return this.funnelService.getFunnelsPathsWithSubRouts(funnels);
  }
}
